module.exports = __webpack_public_path__ + "img/document-equall.3dd0eb62.svg";